import { InjectionToken } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { Observable } from 'rxjs';

export interface ColumnsConfigurator {
  columnDefinitions$: Observable<ColDef[]>;
}

export const ColumnsConfiguratorToken = new InjectionToken<ColumnsConfigurator>(
  'ColumnsConfigurator'
);
